// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d7-a";
export var fulfillmentFormRail = "_d7-9";
export var headerTitleRow = "_d7-c";
export var orderDetailsWrapper = "_d7-7";
export var orderLinkTrigger = "_d7-2";
export var paymentInformationGrid = "_d7-h";
export var paymentSummaryColumn = "_d7-i";
export var shipmentContainer = "_d7-b";
export var shipmentDetailsMainPane = "_d7-8";
export var shipmentNavigationCard = "_d7-5";
export var shipmentNavigationRail = "_d7-3";
export var shipmentNavigationRailHeader = "_d7-4";
export var shipmentSummaryFact = "_d7-e";
export var shipmentSummaryGrid = "_d7-d";
export var shipmentSummaryMetadataRow = "_d7-f";
export var shipmentSummaryTags = "_d7-g";
export var shipmentWorkspace = "_d7-0";
export var shipmentWorkspaceContent = "_d7-6";
export var shipmentWorkspaceHeader = "_d7-1";